module.exports = __webpack_public_path__ + "img/CG1_38.4140f88.png";